class ProductExplorerView {
    constructor(view, splitContent) {
        this.rootEl = view;
        this.splitContent = splitContent;
        this.points = this.rootEl.querySelectorAll('.point');
        this.pointContent = this.rootEl.querySelectorAll('.point-content');

        this.moveContent();

        if (this.havePoints()) {
            this.enablePoint(this.points[0]);
            this.points.forEach(el => {
                el.addEventListener('click', this.handleClick.bind(this));
            });
        }

        if (!this.havePoints()) {
            this.rootEl.classList.add('without-points');
        }

    }

    havePoints() {
        return this.points.length > 0;
    }

    // we can't split our child blocks at render time, so move them to their final columns
    moveContent() {
        const media = this.rootEl.querySelector('.view__media');
        const side2 = this.rootEl.querySelector('.view__location--2');
        if (this.havePoints()) {
            this.points.forEach(el => {
                media.appendChild(el);
            });
        }
        if (!this.splitContent) {
            return;
        }
        // content can be on either side, move some items
        this.pointContent?.forEach(el => {
            if (el.dataset.side === "right") {
                side2.appendChild(el);
            }
        });
    }

    handleClick(e) {
        e.preventDefault();
        this.disablePoints();
        this.enablePoint(e.target);
    }

    // disable all points
    disablePoints() {
        this.pointContent?.forEach(el => {
            el.classList.remove('active');
        });
        this.points?.forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-expanded', false);
        });
    }

    // enable point
    enablePoint(el) {
        el.classList.add('active');
        el.setAttribute('aria-expanded', true);
        document.getElementById(el.getAttribute('aria-controls')).classList.add('active');
    }
}

class ProductExplorer {
    constructor(el) {
        this.views = el.querySelectorAll('.product-explorer__view');
        this.rotateButton = el.querySelector('.view-control--rotate');
        this.nextButton = el.querySelector('.view-control--next');
        this.previousButton = el.querySelector('.view-control--previous');

        this.currentView = 0;

        const splitContent = el.classList.contains('image-center');
        this.views.forEach((view, i) => {
            new ProductExplorerView(view, splitContent);

            if (i === 0) {
                view.classList.add('active');
            }
        });

        if (this.views.length === 1) {
            this.rotateButton?.remove();
            this.nextButton.remove();
            this.previousButton.remove();
            return;
        }

        this.rotateButton?.addEventListener('click', this.next.bind(this));
        this.nextButton.addEventListener('click', this.next.bind(this));
        this.previousButton.addEventListener('click', this.previous.bind(this));

    }

    next() {
        if (this.currentView + 1 === this.views.length) {
            this.currentView = 0;
        } else {
            this.currentView++;
        }
        this.updateActiveView();
    }

    previous() {
        if (this.currentView - 1 < 0) {
            this.currentView = this.views.length - 1;
        } else {
            this.currentView--;
        }
        this.updateActiveView();
    }

    updateActiveView() {
        this.views.forEach(el => {
            el.classList.remove('active');
        });
        this.views[this.currentView].classList.add('active');
    }
}

const explorerSections = document.querySelectorAll('.product-explorer-section');
explorerSections?.forEach(el => new ProductExplorer(el));
